import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Buttons.module.css';



export const RedButton=(props)=>{
	return (
		<button 
			style={props.style} className={[styles.button,styles.red_button].join(' ')} id={props.id} onClick={props.onClick}  
			data-tealium-type={props.type}
			data-tealium-category={props.category}
			data-tealium-action={props.action}
			data-tealium-value={props.value}
		> 
			{props.label}
		</button>
	)
}
export const RedButtonLink=(props)=>{
	return (
		<Link 
			style={props.style} className={[styles.button,styles.red_button].join(' ')} id={props.id} onClick={props.onClick}  
			data-tealium-type={props.type}
			data-tealium-category={props.category}
			data-tealium-action={props.action}
			data-tealium-value={props.value}
			to={props.to}
		> 
			{props.label}
		</Link>
	)
}

export const BlackButton=(props)=>{
	return (
		<button 
			className={[styles.button,props.disabled ? styles.black_button_disabled : styles.black_button].join(' ')}  onClick={props.onClick}
			data-tealium-type={props.type}
			data-tealium-category={props.category}
			data-tealium-action={props.action}
			data-tealium-value={props.value}
		> 
			{props.label}
		</button>
	)
}

export const TwitterButton=(props)=>{
	return (
		<button className={[styles.button,styles.twitter_button].join(' ')}  onClick={props.onClick}> {props.label}</button>
	)
}